import type { SVGProps } from 'react';
const DawnFlagGG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-GG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-GG_svg__a)">
      <path fill="#E8112D" d="M8.381 0h5.238v16H8.381z" />
      <path fill="#E8112D" d="M0 5.333h22v5.333H0z" />
      <path fill="#F9DD16" d="M10.477 2.133h1.048v11.733h-1.048z" />
      <path
        fill="#F9DD16"
        fillRule="evenodd"
        d="m11 12.8 1.047 1.067H9.952z"
        clipRule="evenodd"
      />
      <path fill="#F9DD16" d="M5.238 7.467h11.524v1.067H5.238z" />
      <path
        fill="#F9DD16"
        fillRule="evenodd"
        d="m11 3.2 1.047-1.067H9.952zM6.286 8 5.24 6.933v2.134zM15.715 8l1.047-1.067v2.134z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagGG;
